import React from 'react';
import { EnterCredential } from 'new/elements/flows/EnterCredential';
import { FCFormPageType } from 'new/elements/Form/useForm';
import useCredentialsPage from 'new/components/flows/controller/useCredentialsPage';
import { loadDataCredentials } from 'js/actions';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import useAppDispatch from 'js/hooks/useAppDispatch';
import useLLMProcessor from 'new/elements/flows/ModalConfigureLLM/useLLMProcessor';
import { FORM_TYPE_CREATE_LLM_FLOW } from 'js/constants/formTypes';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_ALL_CREDENTIALS_REQUEST } from 'js/constants/actionTypes';

export const EnterCredentialStep: FCFormPageType<any> = () => {
  const { credentialId, selectedConnection, selectedCredentialInfo } = useLLMProcessor();
  const dispatch = useAppDispatch();
  const {
    onSaveCredential,
    onChangeTemplate,
    selectedTemplate,
    onEditCredential,
    onCredentialSelected,
    onCredentialInfoUpdated,
  } = useCredentialsPage({
    useFormData: useLLMProcessor,
    formType: FORM_TYPE_CREATE_LLM_FLOW,
  });

  const loadCredentialNeeds = () => {
    dispatch(loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key));
  };

  const areCredentialsLoading = useIsLoading(GET_ALL_CREDENTIALS_REQUEST);

  return (
    <EnterCredential
      reload={loadCredentialNeeds}
      areCredentialsLoading={areCredentialsLoading}
      credentialId={credentialId}
      onChangeTemplate={onChangeTemplate}
      selectedTemplate={selectedTemplate}
      onCredentialInfoUpdated={onCredentialInfoUpdated}
      onSaveCredential={onSaveCredential}
      onEditCredential={onEditCredential}
      selectedCredentialInfo={selectedCredentialInfo}
      onCredentialSelected={onCredentialSelected}
      connectionType={selectedConnection}
    />
  );
};

EnterCredentialStep.formConfig = {
  title: 'Authenticate',
};
